<template>
    <div>
        <el-dialog v-dialogDrag title="选择费用模板" :visible.sync="dialogTableVisible" width="95%"
            :before-close="beforeclose">
            <header>
                <el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="120px">
                    <div style="display: flex;flex-grow: 0;">
                        <el-form-item label="费用名称查询" >
                            <el-input clearable v-model="formInline.condition" style="width:300px;margin-left: 10px;" placeholder="请输入关键字"></el-input>
                        </el-form-item>
                        <el-form-item >
                            <el-button type="primary" @click="getData" size="small">查询</el-button>
                            <!-- <el-button type="success" @click="update">增加</el-button> -->
                        </el-form-item>
                    </div>
                    
                </el-form>
            </header>
            <!-- 头 -->
            <div style="padding-bottom: 2px;">
                <el-table highlight-current-row @row-click="getVal" border :data="list" height="calc(100vh - 750px)"
                    overflow-y: auto :cell-style="rowStyle" id="tableId" ref="tableId" min-width="30px" size="small"
                    style="font-size: calc(16vw * 100 / 1920); flex-wrap: nowrap;  margin-top: 0px; overflow-y: auto; min-height: 30vh;">
                    <el-table-column label="序号" type="index" width="60" align="center">
                    </el-table-column>
                    <el-table-column label="模板名称" width="auto" align="center">
                        <template slot-scope="scope">
                            <!-- <i class="iconfont icon-bianmubianma"></i> -->
                            <span style="margin-left: 10px; ">{{ scope.row.templateName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="结算对象" width="auto" align="center">
                        <template slot-scope="scope">
                            <!-- <i class="iconfont icon-bianmubianma"></i> -->
                            <span style="margin-left: 10px">{{ scope.row.custName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建人" width="auto" align="center">
                        <template slot-scope="scope">
                            <!-- <i class="iconfont icon-bianmubianma"></i> -->
                            <span style="margin-left: 10px">{{ scope.row.createMan }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建时间" width="auto" align="center">
                        <template slot-scope="scope">
                            <!-- <i class="iconfont icon-bianmubianma"></i> -->
                            <span style="margin-left: 10px">{{ scope.row.createTime }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="模板备注" width="auto" align="center">
                        <template slot-scope="scope">
                            <!-- <i class="iconfont icon-bianmubianma"></i> -->
                            <span style="margin-left: 10px">{{ scope.row.tempNote }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 明细 -->
            <div>
                <el-divider content-position="left">费用明细</el-divider>
                <el-table ref="multipleTable" height="360px" :cell-style="rowStyle" :data="tableData"
                    border tooltip-effect="dark" size="small"
                    style="width: 100%;font-size: calc(16vw * 100 / 1920); overflow-y: auto; min-height: 35vh;"
                    @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="35" align="center">
                    </el-table-column>
                    <el-table-column label="序号" type="index" width="60" align="center">
                    </el-table-column>
                    <el-table-column label="费用名称" width="auto" align="center">
                        <template slot-scope="scope">
                            <!-- <i class="iconfont icon-bianmubianma"></i> -->
                            <span style="margin-left: 10px;">{{ scope.row.feeName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="币制" width="auto" align="center">
                        <template slot-scope="scope">
                            <!-- <i class="iconfont icon-bianmubianma"></i> -->
                            <span style="margin-left: 10px">{{ scope.row.currency }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="箱型" width="auto" align="center">
                        <template slot-scope="scope">
                            <!-- <i class="iconfont icon-bianmubianma"></i> -->
                            <span style="margin-left: 10px">{{ scope.row.containerType }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="金额" width="auto" align="center">
                        <template slot-scope="scope">
                            <!-- <!-- <i class="iconfont icon-bianmubianma"></i> -->
                            <span style="margin-left: 10px">{{ scope.row.amount }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="备注" width="auto" align="center">
                        <template slot-scope="scope">
                            <!-- <!-- <i class="iconfont icon-bianmubianma"></i> -->
                            <span style="margin-left: 10px">{{ scope.row.note }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-button style="margin-top:0.5%;" type="danger" size="small" plain @click="imFeeDetail">引入费用</el-button>
        </el-dialog>
    </div>
</template>

<script>
import req from '@/utils/index.js'
import url from '@/config/url2.js'
export default {
    name: "selectFee",
    props: ['type'],
    data() {
        return {
            dialogTableVisible: false,
            list: [],//头数据
            tableData: [],//表格明细数据
            formInline:{condition: ''},//费用名称查询
            values: [],
            templateId: '',
        }
    },
    created() {
        // this.getData();
    },
    watch: {
        type: {
            handler(newVal) {
                if(this.values.length){
                    this.$refs.multipleTable.clearSelection();
                }
            },
            deep: true, // 深度监听
            immediate: true // 立即执行
        }
    },
    methods: {
        beforeclose() {
            this.list = [];
            this.tableData = [];
            this.values = [];
            this.formInline.condition = '';
            this.dialogTableVisible = false;
        },
        imFeeDetail() {
            // let val = this.handleSelectionChange();
            this.$emit('customEvent', this.values);
            // this.$emit('calculateCostOnTemplate', this.values);
            this.$parent.calculateCostOnTemplate()
            this.dialogTableVisible = false;
        },
        //选择引入明细
        handleSelectionChange(val) { 
            if (this.type === 1) {
                // val.push(1);
                val.forEach(item => {
                    item.feeType = 1;
                    item.templateId = this.templateId;
                    
                });
                // return val;
                // this.$emit('customEvent', val);
            } else if (this.type === 2) {
                val.forEach(item => {
                    item.feeType = 2;
                    item.templateId = this.templateId;                                     
                });
                // return val;
            }
            this.values = val;
        },
        // 获取明细
        getVal(row, event, column) {
            this.templateId = row.id;          
            let URL = `${url.getDetailById}/${row.id}`
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.tableData = res.data.data;
                    // this.templateId =  this.tableData[0].templateId;
                    this.tableData.forEach(item => {
                        item.company = row.custName;
                        // item.templateId = row.id;
                    });
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    })
                }
            })
        },
        //chaxun获取数据
        getData(id) {
            // this.currentPage = page;
            let URL = `${url.getTemplateByName}?name=${this.formInline.condition}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.list = res.data.data;
                }
            })
        },
        rowStyle() {
            return "text-align:center";
        },
    },
}
</script>

<style lang="css" scoped>
::v-deep .el-dialog__body {
    padding: 22px 20px;
}
::v-deep .el-form-item {
    margin-bottom: 10px !important;
    display: flex ;
    flex-grow: 0 !important;
}
::v-deep .el-dialog {
    margin: 10px auto !important;
}
</style>